document.addEventListener("DOMContentLoaded", async () => {
    const items = document.querySelectorAll(".hero-item");

    await Promise.all(
        [...items].map(async (item) => {
            const pageId = item.dataset.pageId;
            if (!pageId || pageId === "0") return;

            const response = await fetch(`/wp-json/wp/v2/pages/${pageId}`);
            const page = await response.json();

            const url =
                page.link ||
                page.guid?.rendered ||
                `/index.php?page_id=${pageId}`;

            const title = page.title?.rendered || "";

            const titleEl = item.querySelector(".hero-item-title");
            if (titleEl) titleEl.textContent = title;

            const inner = item.querySelector(".hero-item-inner");
            const link = document.createElement("a");
            link.href = url;
            link.title = title;
            link.appendChild(inner.cloneNode(true));

            item.innerHTML = "";
            item.appendChild(link);
        })
    );

    if (window.innerWidth <= 1024) {
        const slider = document.querySelector(".swiper-hero");

        if (slider) {
            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                observer: true,
                observeParents: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }
    }
});